import { createContext, useContext, useState } from "react";

import { Sidebar } from "primereact/sidebar";
import {
  DetailPanelContextType,
  DetailPanelOptions,
  DetailPanelProviderProps,
} from "interfaces";
export const DetailPanelContext = createContext<DetailPanelContextType>({
  showPanel: () => {},
  hidePanel: () => {},
});

export const useDetailPanelProvider = () => {
  const context = useContext(DetailPanelContext);
  return context;
};

export const DetailPanelProvider: React.FC<DetailPanelProviderProps> = ({
  children,
}) => {
  const [panelVisible, setPanelVisible] = useState(false);
  const [panelOptions, setPanelOptions] = useState<DetailPanelOptions>({});

  const showPanel = (options: DetailPanelOptions) => {
    setPanelOptions(options);
    setPanelVisible(true);
  };

  const hidePanel = () => {
    setPanelVisible(false);
  };

  return (
    <DetailPanelContext.Provider value={{ showPanel, hidePanel }}>
      {children}
      <Sidebar
        id="detail-panel"
        className="detail-panel-custom"
        visible={panelVisible}
        header={panelOptions.header}
        icons={panelOptions.icons}
        position={panelOptions.position ?? "right"}
        style={{ width: panelOptions.width ?? "740px" }}
        onHide={() => {
          panelOptions.onHideCallback
            ? panelOptions.onHideCallback()
            : hidePanel();
        }}
      >
        <div className="flex-container column justify-between height-100">
          {panelOptions.body}
          {panelOptions.footer}
        </div>
      </Sidebar>
    </DetailPanelContext.Provider>
  );
};
